import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: "#FAFAFA",
      display: "flex",
      flexWrap: "wrap",
    },
    textFieldLeft: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 150,
    },
    textFieldRight: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 150,
    },
    lessThan: {
      position: "relative",
      top: "1.1rem",
      marginTop: "-1.1rem",
      fontSize: "0.9rem",
      color: "#de3c4b",
    },
  })
);
